import { Menu, Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export function Header({ pageTitle, onToggleSidebar, isSidebarCollapsed }) {
  const { user, logout } = useAuth();

  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const headerClasses = `mayo-header ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`;

  return (
    <header className={headerClasses} data-testid="header">
      {/* Left Section */}
      <div className="flex items-center gap-4">
        <button
          onClick={onToggleSidebar}
          data-testid="sidebar-toggle"
          className="p-2 rounded-md hover:bg-[#F5F5F5] text-[#666666] hover:text-[#101010] transition-colors"
          aria-label="Toggle sidebar"
        >
          <Menu size={24} />
        </button>
        
        <h1 
          className="text-base sm:text-xl font-bold text-[#111111] truncate"
          style={{ fontFamily: 'Poppins, sans-serif' }}
          data-testid="page-title"
        >
          {pageTitle}
        </h1>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-2 sm:gap-4">
        {/* Notifications */}
        <button
          data-testid="notification-bell"
          className="p-2 rounded-md hover:bg-[#F5F5F5] text-[#666666] hover:text-[#101010] transition-colors relative"
          aria-label="Notifications"
        >
          <Bell size={20} />
          {/* Notification badge */}
          <span className="absolute top-1 right-1 w-2 h-2 bg-[#D32F2F] rounded-full"></span>
        </button>

        {/* User Avatar Dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              data-testid="header-user-avatar"
              className="w-9 h-9 rounded-full bg-[#FFFF66] text-[#101010] flex items-center justify-center font-bold text-sm cursor-pointer hover:ring-2 hover:ring-[#CFFF40] transition-all"
              aria-label="User menu"
            >
              {getInitials(user?.name)}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel className="font-normal">
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium text-[#111111]">{user?.name}</p>
                <p className="text-xs text-[#666666]">{user?.email}</p>
                <p className="text-xs text-[#666666] capitalize">Role: {user?.role}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              onClick={logout}
              data-testid="logout-button"
              className="text-[#D32F2F] cursor-pointer"
            >
              Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
